module.exports = __webpack_public_path__ + "8b0b2a39f3d8876ce49cf2b2b70ec77f.png";